import { AppState } from '../../../reducers';
import { NoteTypeState } from './connectwise.notetype.reducer';

export const noteTypesSelector = (state: AppState): NoteTypeState => state.connectWise.noteTypes;
